import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';

export default function PhotoOverlayModal({ show, title, onClose, zIndex, modalStyle, contentStyle, children }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="photo-mypage-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          style={typeof zIndex === 'number' ? { zIndex } : undefined}
        >
          <motion.div
            className="photo-mypage-popup"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            style={modalStyle}
          >
            <div className="photo-mypage-popup-header">
              <h3 className="photo-mypage-popup-title">{title}</h3>
              <button className="photo-mypage-popup-close" onClick={onClose}>
                <Icon icon="solar:close-circle-bold" width={20} height={20} />
              </button>
            </div>
            <div className="photo-mypage-popup-content" style={contentStyle}>
              {children}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


